<template>
  <div>

    <div class='page'>
      <header class="flex justify-center flex-col items-center w-full">
        <div class="header__wrap">
          <p class="text-center uppercase">Country Dashboard</p>
          <h1 class="text-center">Unlock Key Metrics <br>
            for Every African Country</h1>
        </div>
      </header>
      <form class='content' @submit='$router.push({ name: "CountryDashboard", params: { country } })'>
        <label for="country" class="text-black block"> Select a country to begin</label>
        <k-input v-model='country' :optionsDisplay='countries' label='Country' searchInside='countries'
          type='select'></k-input>
        <k-button full submit :disabled="!country">Explore Data</k-button>
      </form>
      <section class="country__wrap">
        <h4 class="text-center">Popular countries</h4>
        <div class="country__list w-full grid grid-cols-2 lg:grid-cols-5 gap-y-8 gap-x-6">
            <router-link :to="{ name: 'CountryDashboard', params: { country: country.name.toLowerCase() } }" class="flex items-center border country__item" v-for="(country, index) in popularCountries"
            :key="index">
              <img :src="getFlag(country.img)" :alt="`${country.name} Flag`" />
              <p>{{ country.name }}</p>
            </router-link>
        </div>
      </section>
    </div>
    <Footer />
  </div>
</template>

<script>
import countries from '@/utils/countries';
import { KButton, KInput } from '@/components';
import { popularCountries } from '../../../utils/popular_countries';
import Footer from '@/components/Footer/Footer.vue';

delete countries.all;

export default {
  name: 'Select',
  components: {
    KInput, KButton, Footer,
  },
  data: () => ({
    country: '',
    countries,
    popularCountries,
  }),
  methods: {
    getFlag(imgName) {
      return require(`@/assets/svg/countries/${imgName}`);
    },
  },
};
</script>

<style lang='scss' scoped src="./SelectCountry.scss"></style>
